import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const OrdenDeCompraFormGroup = ({ iError, iTouched, fIsSubmitting, flagEditarComentarios }) => {
  return (
    <Form.Group>
      <Form.Label text='O. DE COMPRA' htmlFor='input-ordenDeCompra' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='ordenDeCompra'>
          {({ field }) => (
            <Form.InputText
              {...field}
              disabled={fIsSubmitting || flagEditarComentarios}
              isInvalid={iTouched && iError}
              id='input-ordenDeCompra'
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(OrdenDeCompraFormGroup)
